<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="mx-auto flex max-w-5xl flex-col gap-4 p-4">
  <h1 class="mat-headline-4 !mb-0">Accounting</h1>

  <pr-content-container>
    <h2 class="text-xl font-bold">Transaction Types</h2>
    <pr-manual-transaction-types [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <pr-payment-method-availability [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <h2 class="text-xl font-bold">Invoice Due Date</h2>
    <pr-information-box>
      <p class="!mb-0">
        Set the default number of days until an invoice is due after it is
        issued. The default is 14 days. Set to 0 for invoices to be due
        immediately.
      </p>
    </pr-information-box>
    <div class="mt-4 flex flex-wrap gap-8">
      @for (
        practice of organisation.practices$ | async;
        track practice.ref.path
      ) {
        <pr-invoice-due-date-settings
          [practice]="practice"
          [hasMultiplePractices]="organisation.hasMultiplePractices$ | async"
        />
      }
    </div>
  </pr-content-container>

  <pr-content-container>
    <h2 class="text-xl font-bold">Allocation Settings</h2>
    <p class="text-md font-bold">Include Deposits in Allocation</p>
    <pr-information-box>
      <p>
        By default, payments can only be allocated up to the value of a
        practitioner’s treatment, product, and cancellation fees on an invoice.
        When enabled, deposits are also included toward this allocation limit.
      </p>
      <p class="!mb-0">
        Enable this if you want to pay practitioners when deposits are received,
        regardless of when the resulting credit is applied to treatment.
      </p>
    </pr-information-box>
    <div class="mt-4 flex flex-wrap gap-8">
      @for (
        practice of organisation.practices$ | async;
        track practice.ref.path
      ) {
        <pr-allocation-settings
          [practice]="practice"
          [hasMultiplePractices]="organisation.hasMultiplePractices$ | async"
        />
      }
    </div>
  </pr-content-container>

  <pr-content-container>
    <h2 class="text-xl font-bold">Lab Job Income Timestamp</h2>
    <pr-information-box>
      <p class="!mb-0">
        Choose which lab job timestamp is used for practitioner income
        reporting. This determines when lab job costs are attributed to a
        reporting period. The default is the Issued Date (when the lab job has
        been issued to the patient).
      </p>
    </pr-information-box>
    <div class="mt-4 flex flex-wrap gap-8">
      @for (
        practice of organisation.practices$ | async;
        track practice.ref.path
      ) {
        <pr-practitioner-income-settings
          [practice]="practice"
          [hasMultiplePractices]="organisation.hasMultiplePractices$ | async"
        />
      }
    </div>
  </pr-content-container>
</div>
